import { createReducer } from '@reduxjs/toolkit';
import { Part } from '../vehicles/actions';
import {
    listPartsRequest,
    listPartsSuccess,
    listPartsFailure,
    updatePartsRequest,
    updatePartsSuccess,
    updatePartsFailure,
    listPartsDeliveryRequest,
    listPartsDeliverySuccess,
    listPartsDeliveryFailure,
    getPartRequest,
    getPartSuccess,
    getPartFailure,
    setPartRequest,
    resetErrorRequest,
    DeliveryResponse,
} from './actions';

export interface PartState {
    [key: string]: any;
    parts_inventory: Part[];
    parts_requests: Part[];
    parts_tasks: Part[];
    parts: Part[];
    part: Part | null;
    deliveries: DeliveryResponse[];
    loading: boolean;
    error: string | null;
}

const initialState: PartState = {
    parts_inventory: [],
    parts_requests: [],
    parts_tasks: [],
    deliveries: [],
    part: null,
    parts: [],
    loading: false,
    error: null,
};

const partReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(resetErrorRequest, (state) => {
            state.error = null;
        })
        .addCase(listPartsRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listPartsSuccess, (state, action) => {
            state[action.payload.save_as] = action.payload.data;
            state.loading = false;
        })
        .addCase(listPartsFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(updatePartsRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(updatePartsSuccess, (state, action) => {
            action.payload.data.map((part) => {
                let found = false;
                state[action.payload.save_as] = state[action.payload.save_as].map((el: Part) => {
                    if (el.id == part.id) {
                        found = true;
                        return {
                            ...el,
                            ...part,
                        }
                    }
                    return el;
                });
                if (!found) {
                    state[action.payload.save_as].push(part);
                }
            });

            state.loading = false;
        })
        .addCase(updatePartsFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(listPartsDeliveryRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(listPartsDeliverySuccess, (state, action) => {
            state.loading = false;
            //state.deliveries = action.payload;
            let res: Record<string, DeliveryResponse> = {};

            action.payload.forEach(function(el) {
                if (!el?.delivery_order)
                    return;

                if (!(el.delivery_order in res)) {
                    res[el.delivery_order] = {
                        delivery_order: el?.delivery_order,
                        delivery_company: el?.delivery_company || "",
                        delivery_pickup_date: el?.delivery_pickup_date || "",
                        delivery_est_date: el?.delivery_est_date || "",
                        search_str: el?.delivery_order,
                        parts_delivered: 0,
                        parts_total: 0,
                        parts: [],
                    }
                }

                res[el.delivery_order].parts.push(el)
            });

            state.deliveries = Object.values(res);
        })
        .addCase(listPartsDeliveryFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(getPartRequest, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getPartSuccess, (state, action) => {
            state.part = action.payload;
            state.loading = false;
        })
        .addCase(getPartFailure, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(setPartRequest, (state, action) => {
            state.part = action.payload;
        });
});

export default partReducer;
